export const WHITEBOARD_AND_DATABASE_CLASSIFICATION_FF =
	'confluence.frontend.dlp.whiteboard.and.database.classification';
